/**
 * Constants to define the creative's format and layouty
 */

export const CREATIVE_FORMAT_OPTIONS = [
  {
    label: 'Display',
    value: 'DISPLAY'
  },
  {
    label: 'Native Display',
    value: 'NATIVE_DISPLAY'
  },
  {
    label: 'Vídeo',
    value: 'DISPLAY_VIDEO'
  },
  {
    label: 'YouTube',
    value: 'YOUTUBE'
  },
  {
    label: 'Push',
    value: 'PUSH'
  }
]

export const CREATIVE_LAYOUT_OPTIONS = [
  {
    label: '1280x720',
    value: '1280x720',
    format: 'DISPLAY_VIDEO',
    width: 1280,
    height: 720
  },
  {
    label: '1920x1080',
    value: '1920x1080',
    format: 'DISPLAY_VIDEO',
    width: 1920,
    height: 1080
  },
  {
    label: '1440x1080',
    value: '1440x1080',
    format: 'DISPLAY_VIDEO',
    width: 1440,
    height: 1080
  },
  {
    label: '720x1280',
    value: '720x1280',
    format: 'DISPLAY_VIDEO',
    width: 720,
    height: 1280
  },
  {
    label: '1080x1920',
    value: '1080x1920',
    format: 'DISPLAY_VIDEO',
    width: 1080,
    height: 1920
  },
  {
    label: '1080x1440',
    value: '1080x1440',
    format: 'DISPLAY_VIDEO',
    width: 1080,
    height: 1440
  },
  {
    label: '720x720',
    value: '720x720',
    format: 'DISPLAY_VIDEO',
    width: 720,
    height: 720
  },
  {
    label: '1080x1080',
    value: '1080x1080',
    format: 'DISPLAY_VIDEO',
    width: 1080,
    height: 1080
  },
  {
    label: '1920x1920',
    value: '1920x1920',
    format: 'DISPLAY_VIDEO',
    width: 1920,
    height: 1920
  },
  {
    label: '1080x1350',
    value: '1080x1350',
    format: 'DISPLAY_VIDEO',
    width: 1080,
    height: 1350
  },
  // images
  {
    label: '300x250',
    value: '300x250',
    format: 'DISPLAY',
    width: 300,
    height: 250
  },
  {
    label: '300x600',
    value: '300x600',
    format: 'DISPLAY',
    width: 300,
    height: 600
  },
  {
    label: '320x450',
    value: '320x450',
    format: 'DISPLAY',
    width: 320,
    height: 450
  },
  {
    label: '320x480',
    value: '320x480',
    format: 'DISPLAY',
    width: 320,
    height: 480
  },
  {
    label: '336x280',
    value: '336x280',
    format: 'DISPLAY',
    width: 336,
    height: 280
  },
  {
    label: '728x90',
    value: '728x90',
    format: 'DISPLAY',
    width: 728,
    height: 90
  },
  {
    label: '627x627',
    value: '627x627',
    format: 'NATIVE_DISPLAY',
    width: 627,
    height: 627
  },
  {
    label: '1200x627',
    value: '1200x627',
    format: 'NATIVE_DISPLAY',
    width: 1200,
    height: 627
  },
  {
    label: '1920x1080',
    value: '1920x1080',
    format: 'PUSH',
    width: 1920,
    height: 1080
  }
]
